import { render, staticRenderFns } from "./ChapterDetail.vue?vue&type=template&id=2e8f47e8"
import script from "./ChapterDetail.vue?vue&type=script&lang=js"
export * from "./ChapterDetail.vue?vue&type=script&lang=js"
import style0 from "./ChapterDetail.vue?vue&type=style&index=0&id=2e8f47e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports